import { render, staticRenderFns } from "./DNSLookup.vue?vue&type=template&id=05ec1aca&lang=pug&"
import script from "./DNSLookup.vue?vue&type=script&lang=js&"
export * from "./DNSLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports